import { render, staticRenderFns } from "./CustomDateFilter.vue?vue&type=template&id=0d117e29&"
import script from "./CustomDateFilter.vue?vue&type=script&lang=js&"
export * from "./CustomDateFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/components/ui/v-icon/VIcon.vue').default,VDateInput: require('/app/components/ui/v-date-input/VDateInput.vue').default})
